import type { DataTableColumn } from 'naive-ui'
import { t } from '@/locales'

const columnsApprovedAccount: DataTableColumn<any>[] = [
  {
    title: t('common.index'),
    key: 'index',
    width: 80,
    align: 'center',
  },
  {
    title: t('settings.userManagementTab.fullName'),
    key: 'user_name',
    width: 200,
    sorter: false,
    resizable: true,
  },
  {
    title: t('settings.userManagementTab.phone'),
    key: 'user_phone',
    width: 200,
    sorter: false,
    resizable: true,
  },
  {
    title: t('settings.userManagementTab.email'),
    key: 'user_email',
    width: 200,
    sorter: false,
    resizable: true,
  },
  {
    title: t('settings.userManagementTab.approve'),
    key: 'actions',
    width: 140,
    align: 'center',
  },
]

export default columnsApprovedAccount
